<template>
  <v-card outlined>
    <v-card-text class="pa-2 pa-sm-4">
      <v-row dense align="center" class="mb-2">
        <v-col cols="auto">
          <span class="text-h6">События СКУД</span>
        </v-col>
        <v-spacer />
        <v-col cols="auto">
          <v-btn icon @click="getAcsEvents">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="2">
          <v-menu
            ref="menuDateBegin"
            v-model="menuDateBegin"
            :close-on-content-click="false"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="params.dateBegin"
                v-bind="attrs"
                v-on="on"
                prepend-icon="mdi-calendar"
                label="Дата с"
                readonly
                clearable
                dense
                hide-details
                @click:clear="onFilterChange"
              />
            </template>
            <v-date-picker v-model="params.dateBegin" @input="onFilterChange" />
          </v-menu>
        </v-col>

        <v-col cols="12" sm="2">
          <v-menu
            ref="menuDateEnd"
            v-model="menuDateEnd"
            :close-on-content-click="false"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="params.dateEnd"
                v-bind="attrs"
                v-on="on"
                prepend-icon="mdi-calendar"
                label="Дата по"
                readonly
                clearable
                dense
                hide-details
                @click:clear="onFilterChange"
              />
            </template>
            <v-date-picker v-model="params.dateEnd" @input="onFilterChange" />
          </v-menu>
        </v-col>

        <v-col cols="12" sm="2">
          <v-select
            v-model="params.pId"
            :items="accessPoints"
            item-text="name"
            item-value="id"
            label="Точка доступа"
            clearable
            dense
            hide-details
            @change="onPointChange"
          />
        </v-col>

        <v-col cols="12" sm="2">
          <v-select
            v-model="params.cId"
            :items="controllers"
            item-text="name"
            item-value="id"
            label="Контроллер"
            clearable
            dense
            hide-details
            @change="onFilterChange"
          />
        </v-col>

        <v-col cols="12" sm="2">
          <v-select
            v-model="params.categoryType"
            :items="categoryTypes"
            item-text="text"
            item-value="value"
            label="Категория"
            clearable
            dense
            hide-details
            @change="onFilterChange"
          />
        </v-col>

        <v-col cols="12" sm="2">
          <v-combobox
            v-model="params.identifierTypes"
            :items="identifiers"
            item-value="value"
            item-text="text"
            clearable
            multiple
            dense
            hide-details
            label="Тип идентификатора"
            @change="onFilterChange"
          />
        </v-col>
      </v-row>

      <v-row v-if="session.permission.isAllow('elem', 'download_data')" dense>
        <v-col>
          <v-btn text color="primary" @click="downloadReport">
            <v-icon left>mdi-cloud-download</v-icon>
            Выгрузить отчет по СКУД
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-text>
      <v-data-table
        dense
        show-expand
        :headers="headers"
        :items="events.content"
        :options.sync="eventsOptions"
        :server-items-length="events && events.totalElements"
        :loading="loading"
        :footer-props="{ itemsPerPageOptions: [100, 250, 500] }"
        item-key="id"
      >
        <template #item.type="{item}">
          <div>
            <v-icon :color="getTypesColor(item.type)">
              {{ getTypesIcon(item.type) }}
            </v-icon>
          </div>
        </template>

        <template #item.fio="{item}">
          <td v-if="item.userId">
            <a @click="goToUserEdit(item)">
              {{ `${item.name} ${item.surname}` }}
            </a>
          </td>
        </template>

        <template #item.date="{item}">
          {{ localeDateString(item) }}
        </template>

        <template #expanded-item="{headers, item}">
          <td :colspan="headers.length" v-if="item.userId">
            <events-info :event="item" />
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { groupBy, sortBy } from "lodash";
import {
  getControllersEvents,
  getControllers,
  getAccessPointController
} from "@/services/device.service";
import {
  getTypesColor,
  getTypesIcon,
  getTypesName
} from "@/constants/events-type.constants";
import {
  PPS_EDIT_ROUTE,
  STAFF_EDIT_ROUTE,
  USERS_EDIT_ROUTE
} from "../../../router/names";
import { getUserById } from "../../../services/user.service";
import { downloadControllerEvents } from "../../../services/accessEventExport.service";
import { session } from "../../../services/session.service";
import { todayIso } from "../../../utils/date-format";
import EventsInfo from "./EventsInfo";

export default {
  name: "ControllerEvents",
  components: { EventsInfo },
  data() {
    return {
      loading: false,
      events: [],
      menuDateBegin: false,
      menuDateEnd: false,
      user: {},

      headers: [
        { text: "Тип", value: "type" },
        { text: "ФИО", value: "fio" },
        { text: "Дата", value: "date" },
        { text: "Контроллер", value: "controllerName" },
        { text: "Событие", value: "eventName" }
      ],
      identifiers: [
        { text: "Карта", value: "card" },
        { text: "QR-код", value: "qr" },
        { text: "Пульт", value: "console" },
        { text: "Отклонен", value: "reject" }
      ],
      accessPoints: [],
      controllers: [],
      categoryTypes: [
        { text: "Студенты", value: "ENTRANT" },
        { text: "Сотрудники", value: "STAFF" },
        { text: "ППС", value: "PPS" }
      ],
      session,
      restoringQuery: false,
      eventsOptions: {},
      params: {
        dateBegin: todayIso(),
        dateEnd: todayIso(),
        pId: null,
        cId: null,
        identifierTypes: []
      }
    };
  },

  watch: {
    eventsOptions: {
      handler() {
        this.getPagination();
        this.getAcsEvents();
        this.syncToQuery();
      }
    },
    params: {
      deep: true,
      handler() {
        this.syncToQuery();
      }
    }
  },

  mounted() {
    this.restoreFromQuery();
    this.loadAccessPoints();
    this.loadControllers();
  },

  methods: {
    getTypesName,
    getTypesColor,
    getTypesIcon,

    async loadAccessPoints() {
      try {
        this.accessPoints = await getAccessPointController();
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    onPointChange() {
      this.params.cId = null;
      this.loadControllers();
      this.onFilterChange();
    },

    restoreFromQuery() {
      const q = this.$route.query;
      if (Object.keys(q).some(k => k.startsWith("ce_"))) {
        this.restoringQuery = true;
        if (q.ce_dateBegin) this.params.dateBegin = q.ce_dateBegin;
        if (q.ce_dateEnd) this.params.dateEnd = q.ce_dateEnd;
        if (q.ce_pId) this.params.pId = Number(q.ce_pId);
        if (q.ce_cId) this.params.cId = Number(q.ce_cId);
        if (q.ce_categoryType) this.params.categoryType = q.ce_categoryType;
        if (q.ce_identifierTypes)
          this.params.identifierTypes = q.ce_identifierTypes.split(",");
        this.eventsOptions = {
          page: Number(q.ce_page) || 1,
          itemsPerPage: Number(q.ce_size) || 100
        };
        this.$nextTick(() => {
          this.restoringQuery = false;
        });
      }
    },

    syncToQuery() {
      if (this.restoringQuery) return;
      const q = { ...this.$route.query };
      q.ce_dateBegin = this.params.dateBegin || undefined;
      q.ce_dateEnd = this.params.dateEnd || undefined;
      q.ce_pId = this.params.pId || undefined;
      q.ce_cId = this.params.cId || undefined;
      q.ce_categoryType = this.params.categoryType || undefined;
      q.ce_identifierTypes = this.params.identifierTypes?.length
        ? this.params.identifierTypes.join(",")
        : undefined;
      q.ce_page = this.eventsOptions.page || undefined;
      q.ce_size = this.eventsOptions.itemsPerPage || undefined;
      this.$router.replace({ query: q }).catch(() => {});
    },

    onFilterChange() {
      this.eventsOptions = { ...this.eventsOptions, page: 1 };
    },

    async loadControllers() {
      try {
        const controllers = await getControllers();
        let filtered = controllers.filter(
          c => c.type == 5 || (c.type == 0 && c.name)
        );
        if (this.params.pId) {
          filtered = filtered.filter(
            c => c.accessPoint?.id === this.params.pId
          );
        }
        const grouped = groupBy(filtered, c => c.accessPoint?.name || "—");
        const result = [];
        const sortedGroups = sortBy(Object.keys(grouped)).reverse();
        for (const groupName of sortedGroups) {
          const sorted = sortBy(grouped[groupName], ["name"]);
          for (const c of sorted) {
            result.push({
              name: `${c.name}`,
              id: c.id
            });
          }
        }
        this.controllers = result;
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    async getAcsEvents() {
      this.loading = true;
      try {
        this.events = await getControllersEvents({
          ...this.params,
          identifierTypes: this.params.identifierTypes
            .map(identifier =>
              typeof identifier === "string" ? identifier : identifier.value
            )
            .filter(Boolean)
            .toString()
        });
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      } finally {
        this.loading = false;
      }
    },

    localeDateString(item) {
      return new Date(item.date).toLocaleString("ru-RU");
    },

    getPagination() {
      const { page, itemsPerPage } = this.eventsOptions;
      this.params.page = page - 1;
      this.params.size = itemsPerPage;
    },

    async getUser(event) {
      try {
        this.user = await getUserById(event.userId);
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    async downloadReport() {
      const totalElements = this.events?.totalElements || 0;
      if (!totalElements) return;

      const pointName =
        this.accessPoints.find(ap => ap.id === this.params.pId)?.name || null;
      const controllerName =
        this.controllers.find(c => c.id === this.params.cId)?.name || null;

      await downloadControllerEvents({
        totalElements,
        params: {
          ...this.params,
          pointName,
          controllerName
        }
      });
    },

    async goToUserEdit(event) {
      await this.getUser(event);
      const group = this.user.mainGroup.name.toLowerCase();

      await this.$router.push({
        name:
          group === "entrant"
            ? USERS_EDIT_ROUTE
            : group === "staff"
            ? STAFF_EDIT_ROUTE
            : PPS_EDIT_ROUTE,
        params: {
          group,
          userId: event.userId
        }
      });
    }
  }
};
</script>
